import getDeliveryDetails from './getDeliveryDetails';

export const createInnervateURL = ({
  tagID, adkey, isDebug, csId, slug
}) => {
  const domain = 'https://rna.homedepot.com/';
  const { store, zipcode } = getDeliveryDetails();
  const storeQuery = store ? `&store_id=${store}` : '';
  const zipcodeQuery = zipcode ? `&zipcode=${zipcode}` : '';
  const slugQuery = slug ? `&slug=${slug}` : '';
  const adKeyQuery = `?adkey=${adkey}`;
  const personalizationIdQuery = `&personalization_id=${csId}&thd_personalization_id=${csId}`;

  const trx = document.cookie
    .split('; ')
    .find((row) => row.startsWith('trx='))
    ?.split('=')[1];
  const vidQuery = trx ? `&vid=${trx}` : '';

  const aamID = document.cookie
    .split('; ')
    .find((row) => row.startsWith('aam_uuid='))
    ?.split('=')[1];
  const aamQuery = aamID ? `&aam_id=${aamID}` : '';

  const debugQuery = isDebug ? '&debug=emulate' : '';

  // eslint-disable-next-line max-len
  return `${domain}${tagID}${adKeyQuery}${debugQuery}${storeQuery}${zipcodeQuery}${slugQuery}${vidQuery}${aamQuery}${personalizationIdQuery}`;
};
